// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__jaKVC","text":"SelectPayment_text__2ED4I","title":"SelectPayment_title__YA_QZ","btn":"SelectPayment_btn__1Gm89"};